package link.erpango.quip.ui.ocr

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import link.erpango.quip.domain.ocr.OcrError

/**
 * JS/Web photo capture fallback — not implemented yet, so [isSupported] is false and the common
 * UI hides the "take photo" action instead of showing a failing camera.
 */
actual object PlatformPhotoCapture : PhotoCaptureContract {
    actual override val isSupported: Boolean = false

    @Composable
    actual override fun rememberCamera(
        modifier: Modifier,
        onPhotoCaptured: (ByteArray) -> Unit,
        onError: (OcrError) -> Unit,
    ): PhotoCaptureTrigger = PhotoCaptureTrigger {}
}
